import { createSelector } from '@ngrx/store';
import { getStorePageState } from '../store.selectors';

export const getStoreProfileState = createSelector(
  getStorePageState,
  (state) => state.configurationState
);
export const getProfileIsloading = createSelector(
  getStoreProfileState,
  (profile) => profile.isLoading
);
export const getProfileData = createSelector(
  getStoreProfileState,
  (profile) => profile.data
);
export const getProfileHasBeenFetched = createSelector(
  getStoreProfileState,
  (profile) => profile.fetched
);
export const getProfileError = createSelector(
  getStoreProfileState,
  (profile) => profile.error
);
export const getProfileSuccess = createSelector(
  getStoreProfileState,
  (profile) => profile.success
);
